<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1"
       style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
       viewBox="0 0 9713 9713"
       xmlns:xlink="http://www.w3.org/1999/xlink">
   <g id="Vrstva_x0020_1">
    <circle class="fil0" cx="4856" cy="4856" r="4856"/>
     <g id="_804353008">
     <path class="fil1"
           d="M2022 6534c-105,0 -290,-51 -359,-87l0 483 128 44c525,155 646,-276 1263,-49 30,11 36,11 67,20 27,9 36,15 72,27 146,45 311,45 458,2 440,-129 401,-179 881,-29 27,9 37,15 72,27 109,34 276,49 387,19 21,-6 53,-12 80,-20 35,-10 32,-12 64,-23 386,-130 431,-121 808,-3 27,9 37,15 72,27 201,63 344,39 531,-24 278,-93 447,-144 741,-22l140 46c296,94 489,-28 574,-30l0 -483c-143,12 -248,160 -686,-7 -282,-107 -425,-98 -712,-3 -53,17 -94,37 -159,51 -277,61 -318,29 -616,-71 -34,-12 -52,-22 -84,-28 -608,-124 -611,293 -1252,51 -273,-103 -440,-99 -711,-3 -296,105 -399,117 -700,3l-159 -51c-194,-40 -205,-36 -391,-2 -105,19 -338,135 -509,135z"/>
       <path class="fil1"
             d="M1663 7425l0 470c202,107 462,88 675,7 724,-275 767,250 1424,0 724,-275 764,251 1423,0 722,-274 763,249 1424,0 655,-247 723,150 1252,52 44,-8 93,-30 140,-34l0 -483c-324,76 -315,94 -688,-30 -309,-103 -378,-87 -684,8 -358,113 -344,110 -701,3 -509,-153 -443,-68 -880,50 -241,66 -339,9 -544,-50 -159,-46 -326,-122 -553,-57 -151,43 -340,133 -519,138 -290,8 -553,-269 -979,-113 -23,9 -30,13 -54,20 -201,60 -355,131 -602,58 -46,-14 -83,-35 -134,-39z"/>
       <path class="fil1"
             d="M2071 2375l0 3354 310 0 0 -3342c0,-81 79,-124 161,-124l705 0c56,0 121,37 134,102l1 617c-1,110 -23,86 311,86l0 -693c0,-228 -244,-384 -372,-384l-854 0c-171,0 -396,186 -396,384z"/>
       <path class="fil1"
             d="M3383 3625l0 1671c0,64 131,37 310,37l0 -396 433 0 0 260 297 0 0 -805 -297 0 0 260 -433 0 0 -1064c-179,0 -310,-28 -310,37z"/>
       <path class="fil1"
             d="M7047 4021l0 1708c128,0 268,19 363,-71 14,-14 15,-17 28,-33 32,-38 55,-80 55,-144l0 -1237c0,-164 -182,-260 -272,-260 -121,0 -174,-17 -174,37z"/>
       <path class="fil1" d="M4856 5729c179,0 310,27 310,-37l0 -1671c0,-65 -131,-37 -310,-37l0 1745z"/>
       <path class="fil1" d="M4559 4021l0 1708 161 0 0 -1708c0,-49 -35,-37 -124,-37 -28,0 -37,8 -37,37z"/>
       <path class="fil1" d="M5290 4900c0,28 8,37 37,37l1584 0 0 -149 -1621 0 0 112z"/>
       <path class="fil1" d="M5290 4021l0 111 1621 0c0,-105 15,-148 -37,-148l-1547 0c-29,0 -37,8 -37,37z"/>
       <path class="fil1" d="M5290 4553l0 112 1621 0c0,-106 15,-149 -37,-149l-1547 0c-29,0 -37,9 -37,37z"/>
       <path class="fil1" d="M5290 4367c0,29 8,38 37,38l1547 0c52,0 37,-43 37,-149l-1621 0 0 111z"/>
       <path class="fil1" d="M5290 5358c0,79 -11,111 37,111l1547 0c52,0 37,-43 37,-148l-1584 0c-29,0 -37,8 -37,37z"/>
       <polygon class="fil1" points="5290,5197 6911,5197 6911,5061 5290,5061 "/>
       <polygon class="fil1" points="5290,5729 6911,5729 6911,5593 5290,5593 "/>
       <polygon class="fil1" points="3247,3464 3841,3464 3841,3192 3247,3192 "/>
       <polygon class="fil1" points="3247,5729 3841,5729 3841,5457 3247,5457 "/>
       <path class="fil1" d="M7629 4689l0 248 161 0c0,-329 33,-285 -124,-285 -28,0 -37,9 -37,37z"/>
    </g>
   </g>
  </svg>
</template>

<script>
export default {
  name: 'WaterJetPump',
};
</script>

<style scoped>
.fil1 {
  fill: #FEFEFE
}

.fil0 {
  fill: #56D6D1
}
</style>
